import { CDN_BASE_URL, HCLSTORE_PATH } from 'shared/custom/constants/commonConstants';

export const replaceImagePath = (url?: string): string => {
	if (!url) return '';
	return url.replace(HCLSTORE_PATH, CDN_BASE_URL);
};
